export const DOMAIN_ASSET_TYPES: TAssetType[] = ['domain', 'subdomain', 'email']

export const ASSET_TYPE_LABELS = {
    domain: 'Root Domain',
    email: 'Email Domain',
    subdomain: 'Subdomain',
    integration: 'Integration',
    device: 'Device',
    user: 'User',
    cloud_app: 'Cloud App',
}
